<template>
  <div>
    <transition name="fade">
      <v-overlay :z-index="201" v-if="showEditDrives"></v-overlay>
    </transition>
    <v-dialog persistent :value="showEditDrives" scrollable hide-overlay>
      <v-card class="unmarkable">
        <v-card-title>
          <v-icon>
            $vuetify.icons.editDrives
          </v-icon>
          &nbsp; Edit drives
        </v-card-title>
        <v-divider />
        <v-card-text>
          <draggable
            v-model="drives"
            group="drives"
            @start="drag = true"
            @end="drag = false"
            @change="onChange"
          >
            <v-card
              v-for="(drive, driveIndex) in drives"
              :key="drive.displayName + driveIndex"
              class="pickTagCard"
              color="grey lighten-3"
            >
              <v-card-text>
                <v-layout justify-space-between>
                  <v-icon>menu</v-icon>
                  <div :style="{ width: '100%', textAlign: 'left' }">
                    <img
                      :src="drive.imagePath"
                      :style="{
                        height: '1.5em',
                        paddingRight: '10px',
                        paddingLeft: '10px',
                        verticalAlign: 'middle'
                      }"
                    />
                    {{ drive.displayName }} [{{ getUnit(drive.showUnit) }}]
                  </div>
                  <v-icon color="red" @click="deleteDrive(drive, driveIndex)"
                    >delete</v-icon
                  >
                </v-layout>
              </v-card-text>
            </v-card>
          </draggable>
          <v-card class="pickTagCard" @click="addNewDrive">
            <v-card-text>
              <v-layout justify-space-between row>
                <v-icon>add</v-icon>
                Add new drive
                <v-icon>add</v-icon>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary darken-1" text @click="closeEditDrives"
            >Finished</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import {
  ADD_DRIVE,
  REMOVE_DRIVE,
  MOVE_DRIVES
} from "../../store/modules/uptData/constants";
import { TOGGLE_SHOW_EDIT_DRIVES } from "../../store/modules/showComponents/constants";
import { NEW_BUTTON_SELECTION_DIALOG } from "../../store/modules/buttonSelectionDialog/constants.js";
import { NEW_OK_CANCEL_DIALOG } from "../../store/modules/okCancelDialog/constants.js";
const _ = require("lodash");
import { pickTypesSettings } from "../utils/tableEditorHeaderHelper.js";
import { notificationMixin } from "../mixins/notificationMixin.js";
import { unitConverter } from "../utils/unitConverter";
import uptFile from "../utils/nonReactiveState/uptFile";
import eventBus from "../utils/eventBus";

export default {
  name: "EditDrives",

  components: {
    draggable
  },

  mixins: [notificationMixin],

  data: function() {
    return {
      drives: null,
      drag: null
    };
  },

  computed: {
    showEditDrives() {
      return this.$store.state.showComponents.showEditDrives;
    },
    availableDrives() {
      const drives = [];
      _.forEach(pickTypesSettings, pickType => {
        if (!_.isNil(pickType.name)) {
          drives.push(pickType);
        }
      });
      return _.orderBy(removeNonAddableDrives(this.drives, drives));
    }
  },

  watch: {
    showEditDrives(newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.drives = this.currentDrives();
      }
    }
  },

  methods: {
    currentDrives() {
      return uptFile.pickData.driveData.tagNames.map(t => pickTypesSettings[t]);
    },
    closeEditDrives() {
      eventBus.$emit("fullUpdate", { retainScrollPosition: true });
      this.$store.dispatch(TOGGLE_SHOW_EDIT_DRIVES);
    },
    async addNewDrive() {
      const dialog = await this.$store.dispatch(NEW_BUTTON_SELECTION_DIALOG, {
        title: "Add new drive",
        label: "Select a drive...",
        selection: this.availableDrives,
        icon: "add"
      });
      if (dialog.cancelled) {
        return;
      }
      await this.$store.dispatch(ADD_DRIVE, dialog.result);
      this.drives = this.currentDrives();
    },
    async deleteDrive(drive, driveIndex) {
      if (canDriveBeRemoved(this.drives.map(d => d.name), drive.name)) {
        const result = await this.$store.dispatch(NEW_OK_CANCEL_DIALOG, {
          title: "Remove drive",
          text: `Do you really want to remove the drive "${
            drive.displayName
          }"?`,
          okText: "Yes",
          cancelText: "No",
          icon: "warning",
          layer: 1
        });
        if (result) {
          await this.$store.dispatch(REMOVE_DRIVE, driveIndex);
        }
        this.drives = this.currentDrives();
      } else {
        this.errorNotification("Drive can not be removed.");
      }
    },
    async onChange(element) {
      await this.$store.dispatch(MOVE_DRIVES, {
        fromIndex: element.moved.oldIndex,
        toIndex: element.moved.newIndex
      });
      this.drives = this.currentDrives();
    },
    getUnit(driveShowUnit) {
      return unitConverter.lookupUnitLabel(driveShowUnit);
    }
  }
};

function removeNonAddableDrives(driveList, newDrives) {
  const nonAddableDrives = [
    pickTypesSettings.PickDensityPer100m,
    pickTypesSettings.MainSpeed,
    pickTypesSettings.RibbonWidthCmm,
    pickTypesSettings.ReedY,
    pickTypesSettings.NeedleY
  ];
  const currentDriveNames = driveList.map(d => d.name);
  nonAddableDrives.forEach(s => {
    if (currentDriveNames.includes(s.name)) {
      _.remove(newDrives, d => d.displayName === s.displayName);
    }
  });

  return newDrives;
}

function canDriveBeRemoved(driveList, drive) {
  const nonRemovableDriveNames = [
    pickTypesSettings.PickDensityPer100m.name,
    pickTypesSettings.MainSpeed.name,
    pickTypesSettings.RibbonWidthCmm,
    pickTypesSettings.ReedY,
    pickTypesSettings.NeedleY
  ];
  let canRemove = true;

  nonRemovableDriveNames.forEach(s => {
    if (drive === s && _.filter(driveList, d => d === s).length <= 1) {
      canRemove = false;
    }
  });
  return canRemove;
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.pickTagCard {
  width: 80%;
  margin: 3px auto;
}
</style>
